var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('div',{staticClass:"not-found"},[_c('font-awesome-icon',{attrs:{"icon":"bug","size":"4x"}}),_c('h1',[_vm._v("Seite nicht gefunden")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }